

$(document).ready(function(){
$('.customer-links a').text("");
  $('.mini-cart-wrapper .cart-count .cart-count-text').text(""); 
// For submenu
  
$('.mega-nav-list').each(function(){
 
  var listwrapper=$(this);
  var submenuParent=" ";
  listwrapper.find('li').each(function(){
  
    var listitem=$(this);
 
    
      if(!listitem.hasClass('mega-nav-list-title')){

        listitem.addClass('submenu_item');
        if(submenuParent == " "){
          submenuParent=listitem.parent();

          submenuParent.addClass('submenu_parent');
        }

      }
  
  })

})

//Add to cart

$('.product-hover-box .add-to-cart-trigger ').on('click',function(){

  var productId=$(this).attr('product-id');

  var mydata={
     "quantity": 1,
     "id": productId
  }
  
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: mydata,
    dataType: "json",
    success: function(result){
	 
      swal("The product is added to cart.", {
  buttons: false,
  timer: 1500,
      }).then(function(){
      location.reload();
      });
      
    },
    error:function(error){
    console.log(error);
    }
  });


});

  //Hhide empty description on pdp page
  $('.template-product .product-description p').each(function(){ 
    var len=$(this).text().trim().length; 
    if(len == 0){ 
      $(this).hide();
    }
  });
  
   //Disable sold out product
  $('.disable-product').each(function(){ 
    var self=$(this);
    self.css('pointer-events','none');
    
  })
  
});


